import React, { Fragment, useEffect, useState, useRef} from 'react'
import PropTypes from 'prop-types';

import mixpanel from 'mixpanel-browser';

// Redux
import { connect } from 'react-redux';

// Actions
import { add_To_Recent_History, setPage, toggleAuthModal, togglePostModal, toggleSideNav } from '../actions/navActions';
import { setAlert } from '../actions/alertActions';
import { getCategoryPhotos, getPostsByCategory, set_ShowBottomSpinner } from '../actions/postActions';
import { getCategoryByUrlHandle, setCategory } from '../actions/categoryActions';

// Side effects
import TriggerSideEffects from '../sideEffects/TriggerSideEffects';
import TriggerAlerts from '../sideEffects/TriggerAlerts/TriggerAlerts';

// Components
import Layout from '../components/layout/Layout';
import TweetBox from '../components/TweetBox/TweetBox';
import Spinner from '../components/common/Spinner';
import Post from '../components/Post/Post';
import { Button } from '@material-ui/core';
import { HorizontalNav } from '../components/common/HorizontalNav';

// Icons
import CloseIcon from '@material-ui/icons/Close';

import STUDENT_ONLY_TYPES from '../utils/constant_variables/STUDENT_ONLY_TYPES';
import FILTER_OPTIONS from '../utils/constant_variables/FILTER_OPTIONS';
import { CATEGORY_LIST } from '../utils/constant_variables/CATEGORIES_LIST';
import replaceHyphenWithSpace from '../utils/reusable_functions/replace_Hyphens_With_Space';
import Empty_Card from './MediaPage/Empty_Card';
import Image_Block from './MediaPage/Image_Block';

const CategoryPage = ({
    getPostsByCategory,
    getCategoryPhotos,
    set_ShowBottomSpinner,
    getCategoryByUrlHandle,
    setCategory,
    toggleSideNav, 
    setPage, 
    add_To_Recent_History,
    toggleAuthModal,
    togglePostModal,
    setAlert,
    auth, 
    nav: { 
        sideNav, 
        page, 
        postModal,
        website,
        website_loading
    },
    post,
    category: {
        category,
        loading
    },
    match
}) => {
    // Analytics 
    const [sentMixpanel, setSentMixpanel] = useState(false);

    // Window width
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    // Check if user is verified
    const [checkedVerification, setCheckedVerification] = useState(false);
    const [checkedVerification_schoolEmail, setCheckedVerification_schoolEmail] = useState(false);

    // Posts
    const [postList, setPostList] = useState([]);
    const [gotPosts, setGotPosts] = useState(false);

    // Scroll direction - for displaying top nav bar
    const [scrollDirection, setScrollDirection] = useState("up");
    const [oldScrollY, setOldScrollY] = useState(window.scrollY);

    // Inifite scroll
    // Temporarily disable to load more function to avoid duplicate fetch requests
    const [canLoadMore, setCanLoadMore] = useState(true);

    // URL and filter
    const url_filter = (window.location.href);
    const url = new URL(url_filter);
    const filter = url.searchParams.get("filter");
    const activeTab = url.searchParams.get("show");
    const intent_filter = url.searchParams.get("intent");
    const hostname = window.location.hostname;
    const url_handle = match.params.url_handle;

    const SPACE_HEIGHT = 250; // Hieght of className 'no-rides' which is a spacer to make sure user can always scroll down
    
    // Determine window size breakpoints
    const isMobile = windowWidth <= 769;
    const isTablet = windowWidth <= 1000;
    const notFullScreen = windowWidth <= 1170;

    // Listen for window resize event and update window width state
    useEffect(() => {

        // Add event listener for window resize
        window.addEventListener('resize', () => handleWindowSizeChange());

        // Clean up by removing event listener on component unmount
        return () => window.removeEventListener('resize', () => handleWindowSizeChange());
    }, []);

    // Update window width state on window resize
    const handleWindowSizeChange = () => {
        setWindowWidth(window.innerWidth);
    };
    
    useEffect(() => {
        setPage('home');
        add_To_Recent_History(url.pathname);  // current url
        
        // Display alert if the filter parameter is set to 'notify-posted'
        if(filter && filter === 'notify-posted') {
            setAlert('Your post was sent', 'okay')
        } 

    }, [filter]);

    // Fetch the categroy data based on the url parameter
    useEffect(() => {
        if(!url_handle) return;
        // getCategoryByUrlHandle(url_handle);
        const categoryData = CATEGORY_LIST.find(item => item.url_handle === url_handle.toLowerCase());
        
        setCategory(categoryData);

    }, [url_handle])

    // Get sports match posts if sports match exists and on correct page
    useEffect(() => {
        if(!category || website_loading) return;
        setGotPosts(false);
        fetchPosts_Category();

    }, [category, website, website_loading, activeTab]);

    // Render posts list for display
    useEffect(() => {

        renderPostList();
    }, [post.posts, canLoadMore]);

    // -- Analytics stuff -- 

    // Track if Action has been tracked yet, (stores postId & current index of display ads)
    const trackedViews = useRef(new Set());
    const trackedDms = useRef(new Set());
    const trackedCopiedLinks = useRef(new Set());
    const trackedLinkClicks = useRef(new Set());
    const sponsoredIndex = useRef(0);
    let analyticsMetaData = {
        trackedViews,
        trackedDms,
        trackedCopiedLinks,
        trackedLinkClicks,
        sponsoredIndex,
        userId: auth?.user?._id
    }

    // -- End: Analytics stuff --

    // Get initial set of posts
    const fetchPosts_Category = () => {

        if(category) {
            if(activeTab === 'photos') {
                // Load posts with photos if on the profile's 'photos' tab
                getCategoryPhotos({ category_obj: category, group_id: website?._id })
                setGotPosts(true);
            } else {
                // Load all posts
                getPostsByCategory({ category_obj: category, group_id: website?._id, filter_tags: intent_filter ? [intent_filter] : null });
                setGotPosts(true);
            }
        }
    }

    // Function to load more paginated posts
    const loadMore = async (lastPage_doc) => {
        try {
            // Temporarily disable to load more function to avoid duplicate fetch requests
            setCanLoadMore(false);

            // Show spinner
            set_ShowBottomSpinner(true);

            if(!website_loading) {
                if(activeTab === 'photos') {
                    // Load posts with photos if on the 'photos' tab
                    getCategoryPhotos({ category_obj: category, group_id: website?._id, lastPageDoc: lastPage_doc })
                } else {
                    // Load all posts
                    getPostsByCategory({ category_obj: category, group_id: website?._id, lastPageDoc: lastPage_doc, analyticsMetaData, filter_tags: intent_filter ? [intent_filter] : null })
                }
            }
        } catch (error) {
            console.log("ERROR loading more", error);
        } finally {
            // Re-enable the load more capabilty
            setCanLoadMore(true);
        }
    }

    // Infinite scroll AND handle top nav bar display
    const handleScroll = (e) => {
        const { offsetHeight, scrollTop, scrollHeight} = e.target

        const newScrollY = offsetHeight + scrollTop;

        // --- Handle top nav bar display
        if(isMobile) {
            if(oldScrollY < newScrollY){

                // scrolling down - hide top nav
                setScrollDirection("down");

                if(document.getElementById('feed-header') !== null) {
                    document.getElementById('feed-header').classList.remove("active");
                }
                
            } else {

                // scrolling up - show top nav
                setScrollDirection("up");

                if(document.getElementById('feed-header') !== null) {
                    document.getElementById('feed-header').classList.add("active");
                }
            }
        }
        // --- END Handle top nav bar display

        // update the scroll position for future comparison
        setOldScrollY(newScrollY)

        // Check if the user has scrolled to the bottom of the content and conditions for loading more posts are met
        if (newScrollY >= scrollHeight - (SPACE_HEIGHT+1) && !post.show_bottom_spinner && !post.no_more_posts && post.posts.length > 0 && canLoadMore) {
            console.log('scrolling');
            loadMore(post.last_page_doc);
        }
    }

    // Handle create Post Modal Toggle
    const handleToggle_PostModal = () => {
        if(auth.user) {
            togglePostModal();
        } else {
            toggleAuthModal('post');
        }
    }

    // Check if user is verified. If no redirect to verify page
    if(auth.user && !auth.user.verified && !checkedVerification) {
        window.location.href = '/verify';

        setCheckedVerification(true);
    }

    // Check if user's school email is verified. If no redirect to school email page (only for 'students only' groups)
    if(auth.user && !auth.user.school_verified && !checkedVerification_schoolEmail && STUDENT_ONLY_TYPES.includes(website?.privacy?.toLowerCase())) {
        window.location.href = '/settings/account/school_email';

        setCheckedVerification_schoolEmail(true);
    }

    const renderPostList = async () => {
        setPostList([]);

        if((post.posts === null && auth.loading) || !gotPosts) {
            setPostList([(
                <div className="no-rides">
                    <Spinner />
                </div>
            )])
        }
        else { 
            if(post.posts.length > 0) {
                post.posts.map(post_doc => {
                    if (activeTab === 'photos') {
                        setPostList(postList => [...postList, (
                            <Image_Block key={post_doc._id} detailPost={post_doc} />
                        )])
                    } else {
                        const renderPostRecursive = (postComments, parentPost) => {
                        
                            const lastComment = postComments[postComments.length - 1]; // Get the last comment
        
                            return (
                                <Fragment>
                                    <Post key={lastComment._id} postDoc={lastComment} parentPost={parentPost} />
        
                                    {/* Recursive call to render comments of comments */}
                                    {lastComment.commentsOfComments && lastComment.commentsOfComments.length > 0 && (
                                        <div className="comments-of-comments">
                                        {renderPostRecursive(lastComment.commentsOfComments, lastComment)}
                                        </div>
                                    )}
                                </Fragment>
                            );
        
                        };
        
                        if(post_doc.commentsOfComments && post_doc.commentsOfComments.length > 0) {
                            setPostList(postList => [...postList, (
                                <div className='post_container'>
                                    <Post key={post_doc._id} postDoc={post_doc} />
        
                                    {renderPostRecursive(post_doc.commentsOfComments, post_doc)}
                                </div>
                            )])
                        } else {
                            setPostList(postList => [...postList, (
                                <Post key={post_doc._id} postDoc={post_doc} />
                            )])
                        }
                    }
                }) 
            } else {
                if (activeTab === 'photos') {
                    setPostList(postList => [...postList, (
                        <div className="no-rides">
                            <h1>No photos yet</h1>
                        </div>
                    )])
                } else {
                    if(intent_filter) {
                        setPostList(postList => [...postList, (
                            <div className="no-posts-container">
                                <div className="no-chats">
                                    <h1 className='placeholder_title'>No posts yet</h1>
                                    <p className='placeholder_text'>Couln't find anything under that filter.</p>
        
                                    <Button 
                                        onClick={handleToggle_PostModal}
                                        variant="outlined" 
                                        className="sidebar__tweet minWidth black"
                                    >
                                        Create A Post
                                    </Button>
                                    
                                </div>
                            </div>
                        )])
                    } else {
                        setPostList(postList => [...postList, (
                            <div className="no-posts-container">
                                <div className="no-chats">
                                    <h1 className='placeholder_title'>Be the first...</h1>
                                    <p className='placeholder_text'>...to create a post, it's so easy!</p>
        
                                    <Button 
                                        onClick={handleToggle_PostModal}
                                        variant="outlined" 
                                        className="sidebar__tweet minWidth black"
                                    >
                                        Create A Post
                                    </Button>
                                    
                                </div>
                            </div>
                        )])
                    }
                }
            }
        } 

        setGotPosts(true);
    }

    // Function to handle Mixpanel analytics
    const handleMixpanel = () => {
        mixpanel.init(process.env.REACT_APP_MIXPANEL_ID);
        mixpanel.track("Category Page View");
    }

    // Trigger Mixpanel analytics on initial render in production mode
    if(process.env.NODE_ENV === 'production' && !sentMixpanel && !hostname.includes('xbuysell')) {
        handleMixpanel();
        setSentMixpanel(true);
    }

    return (
        <Fragment>
            {/* // -- Trigger Alerts on page load --
            // ----------------------------------
            // after performing an action in another part of the app, user might get redirect to this page.
            // show alerts to user, on their screen, that are pending in localStorage */}

            <TriggerAlerts />

            {/* // -- Trigger Side Effects on page load --
            // ----------------------------------
            // Make sure user account passes all checks and trigger any other system audits */}

            <TriggerSideEffects />

            {/* // -- END: Trigger Alerts on page load -- */}
            
            <Layout handleScroll={handleScroll} sideNav={sideNav} handleSlideMenu={toggleSideNav} page="category" page_title={replaceHyphenWithSpace(url_handle || '')}>
                
                {auth.loading || website_loading ? (
                    <Fragment>
                        <Spinner />
                    </Fragment>
                ) : !auth.isAuthenticated ? (
                    <Fragment>
                        <div className="no-rides">
                            <h1 className='placeholder_title'>Your not logged in.</h1>
                            <p className='placeholder_text'>Log in to view this page.</p>

                            <Button 
                                onClick={() => toggleAuthModal()}
                                variant="outlined" 
                                className="sidebar__tweet minWidth black"
                            >
                                Click to Log in
                            </Button>
                        </div>

                        <div className="no-rides"></div>
                    </Fragment>
                ) : (
                    <Fragment>

                        <div className="feed_headerTabs">
                            <div className={`${(activeTab === null || activeTab === undefined || activeTab === 'posts') && 'active'}`} onClick={() => window.location = `/category/${url_handle}`}>
                                <h3>Posts</h3>
                                <div className="block__underline"></div>
                            </div>

                            <div className={`${(activeTab && activeTab === 'photos') && 'active'}`} onClick={() => window.location = `/category/${url_handle}?show=photos`}>
                                <h3>Photos</h3>
                                <div className="block__underline"></div>
                            </div>
                        </div>
                        
                        {(activeTab === 'photos') ? (
                            <Fragment>
                                {/* Filter Options */}
                                <div style={{margin: '13px 0 3px'}}>
                                    <HorizontalNav>
                                        {CATEGORY_LIST.filter(item => item.parent_id?.includes(category?._id)).map(item => {
                                            return (
                                                <div
                                                    onClick={() => {
                                                        window.location.href = `/category/${item.url_handle}?show=photos`;
                                                    }}
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        padding: '0 16px',
                                                        boxSizing: 'border-box',
                                                        height: '33px',
                                                        minWidth: 'fit-content',
                                                        borderRadius: '9999px',
                                                        backgroundColor: '#f3f4f6',
                                                        color: '#4b5563',
                                                        fontSize: '14px',
                                                        fontWeight: 600,
                                                        fontFamily: 'sans-serif',
                                                        transition: 'background-color 0.15s ease-in-out',
                                                        cursor: 'pointer',
                                                        marginLeft: '5px'
                                                    }}
                                                >
                                                    {item.name}
                                                </div>
                                            )
                                        })}
                                        
                                    </HorizontalNav>
                                </div>

                                {post.posts.length > 0 ? (
                                    <div style={{width: '100%', height: 'fit-content', display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gridAutoRows: 'min-content', borderBottom: '1px solid #ddd'}}>
                                        
                                        {postList}

                                        {(!post.no_more_posts && post.posts.length !== 0) && (<Empty_Card last_page_doc={post.last_page_doc} page={"gallery"} loadMore={loadMore} setCanLoadMore={setCanLoadMore} canLoadMore={canLoadMore} />)}
                                    </div>
                                ) : postList}
                            </Fragment>
                        ) : (
                            <Fragment>
                                {/* Filter Options */}
                                <div style={{margin: '13px 0 3px'}}>
                                    <HorizontalNav>
                                        {intent_filter && (
                                            <div
                                                onClick={() => {
                                                    // Create a copy of the current url object
                                                    const current_url = new URL(url_filter);
                                                    // remove any url variables 
                                                    current_url.searchParams.delete('intent');
                                                    // reload page
                                                    window.location.href = current_url.href;
                                                }}
                                                style={{
                                                    // display: 'inline-block',
                                                    // alignSelf: 'stretch',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    height: '33px',
                                                    minWidth: '33px',
                                                    borderRadius: '9999px',
                                                    backgroundColor: '#f3f4f6',
                                                    color: '#4b5563',
                                                    transition: 'background-color 0.15s ease-in-out',
                                                    cursor: 'pointer',
                                                    marginLeft: '5px',
                                                    marginRight: '5px'
                                                }}
                                                className='icon_20'
                                            >
                                                <CloseIcon />
                                            </div>
                                        )}
                                        {FILTER_OPTIONS.map(item => {
                                            const isActive = item._id === intent_filter;
                                            return (
                                                <div
                                                    onClick={() => {
                                                        // Create a copy of the current url object
                                                        const current_url = new URL(url_filter);
                                                        if(!isActive) {
                                                            // add this filter's ID to the url variables (automatically handles ? or & formatting)
                                                            current_url.searchParams.set('intent', item._id?.trim());
                                                        } else {
                                                            // add this filter's ID to the url variables (automatically handles ? or & formatting)
                                                            current_url.searchParams.delete('intent');
                                                        }
                                                        // reload page
                                                        window.location.href = current_url.href;
                                                    }}
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        padding: '0 16px',
                                                        boxSizing: 'border-box',
                                                        height: '33px',
                                                        minWidth: 'fit-content',
                                                        borderRadius: '9999px',
                                                        backgroundColor: isActive ? '#3b82f6' : '#f3f4f6',
                                                        color: isActive ? '#ffffff' : '#4b5563',
                                                        fontSize: '14px',
                                                        fontWeight: 600,
                                                        fontFamily: 'sans-serif',
                                                        transition: 'background-color 0.15s ease-in-out',
                                                        cursor: 'pointer',
                                                        marginLeft: '5px'
                                                    }}
                                                >
                                                    {item.name}
                                                </div>
                                            )
                                        })}

                                        {CATEGORY_LIST.filter(item => item.parent_id?.includes(category?._id)).map(item => {
                                            return (
                                                <div
                                                    onClick={() => {
                                                        window.location.href = `/category/${item.url_handle}`;
                                                    }}
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        padding: '0 16px',
                                                        boxSizing: 'border-box',
                                                        height: '33px',
                                                        minWidth: 'fit-content',
                                                        borderRadius: '9999px',
                                                        backgroundColor: '#f3f4f6',
                                                        color: '#4b5563',
                                                        fontSize: '14px',
                                                        fontWeight: 600,
                                                        fontFamily: 'sans-serif',
                                                        transition: 'background-color 0.15s ease-in-out',
                                                        cursor: 'pointer',
                                                        marginLeft: '5px'
                                                    }}
                                                >
                                                    {item.name}
                                                </div>
                                            )
                                        })}
                                        
                                    </HorizontalNav>
                                </div>

                                {/* Render TweetBox component if user is authenticated and postModal is false */}
                                {/* {!postModal && !intent_filter ? (
                                    <TweetBox isTablet={isMobile} mobile_redirect={isMobile} />
                                ) : null} */}

                                {/* <div style={{background: '#e6ecf0', height: '1px'}}></div> */}
                                
                                {/* Render the postList */}
                                {postList}

                                {/* Render a spinner at the bottom if there are more posts to load */}
                                {post.show_bottom_spinner && !post.no_more_posts && <Spinner />}
                                {/* <button onClick={loadMore}>More Posts</button> */}
                                
                                {/* Display a message when there are no more posts */}
                                <div className="no-rides">{(post.no_more_posts && post.posts.length !== 0) && "You've reached the end."}</div>
                            </Fragment>
                        )}

                    </Fragment>
                )}

            </Layout>
        </Fragment>
    )
}

CategoryPage.propTypes = {
    getPostsByCategory: PropTypes.func.isRequired,
    getCategoryPhotos: PropTypes.func.isRequired,
    set_ShowBottomSpinner: PropTypes.func.isRequired,
    getCategoryByUrlHandle: PropTypes.func.isRequired,
    setCategory: PropTypes.func.isRequired,
    toggleSideNav: PropTypes.func.isRequired,
    setPage: PropTypes.func.isRequired, // Function prop to set the current page in the navigation
    add_To_Recent_History: PropTypes.func.isRequired,
    toggleAuthModal: PropTypes.func.isRequired,
    togglePostModal: PropTypes.func.isRequired,
    setAlert: PropTypes.func.isRequired,
    post: PropTypes.object.isRequired,
    nav: PropTypes.object.isRequired,
    auth: PropTypes.object.isRequired, // Object prop representing the authentication state of the user
    ad: PropTypes.object.isRequired,
    category: PropTypes.object.isRequired,
}

const mapStateToProps = state => ({

    // Mapping the states from the Redux store to the below props
    post: state.post,
    nav: state.nav,
    auth: state.auth,
    ad: state.ad,
    category: state.category
});

export default connect(mapStateToProps, { 

    // Connecting actions to the component
    getPostsByCategory,
    getCategoryPhotos,
    set_ShowBottomSpinner,
    getCategoryByUrlHandle,
    setCategory,
    toggleSideNav, 
    setPage, 
    add_To_Recent_History,
    toggleAuthModal,
    togglePostModal,
    setAlert
})(CategoryPage);
